// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "chartkick/chart.js"
import Chart from "chart.js/auto"
import { BarWithErrorBarsController, BarWithErrorBar } from "chartjs-chart-error-bars"
Chart.register(BarWithErrorBarsController, BarWithErrorBar)
import "../js/error_bar_chart.js"
import '../js/bootstrap_js_files.js'
import '../images/gear.png'

Rails.start()
Turbolinks.start()
ActiveStorage.start()
